import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to enable real-time tracking updates for an order
 */
export const useRealTimeTracking = (orderId: string | undefined) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!orderId) return;

    console.log('Setting up real-time tracking for order:', orderId);

    // Subscribe to tracking events for this order
    const channel = supabase
      .channel(`tracking-${orderId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'tracking_events',
          filter: `order_id=eq.${orderId}`,
        },
        (payload) => {
          console.log('New tracking event received:', payload);
          
          // Invalidate tracking events query to refetch
          queryClient.invalidateQueries({ queryKey: ['tracking-events', orderId] });
          
          // Optionally, you could also invalidate the order query if needed
          queryClient.invalidateQueries({ queryKey: ['order', orderId] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'tracking_events',
          filter: `order_id=eq.${orderId}`,
        },
        (payload) => {
          console.log('Tracking event updated:', payload);
          queryClient.invalidateQueries({ queryKey: ['tracking-events', orderId] });
        }
      )
      .subscribe();

    // Cleanup subscription on unmount
    return () => {
      console.log('Cleaning up real-time tracking subscription');
      supabase.removeChannel(channel);
    };
  }, [orderId, queryClient]);
};
